var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9B218;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,0h22c2.8,0,5,2.2,5,5v22c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5C0,2.2,2.2,0,5,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.6,17.8c-0.3,0-0.6,0.3-0.6,0.6v2.8c0,0.2-0.2,0.4-0.4,0.4h-9.3c-0.2,0-0.4-0.2-0.4-0.4v-2.8 c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6v2.8c0,0.8,0.7,1.5,1.5,1.5h9.3c0.8,0,1.5-0.7,1.5-1.5v-2.8 C22.1,18,21.9,17.8,21.6,17.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.7,17.5L18.7,17.5c0.2,0.2,0.2,0.6,0,0.8l0,0l0,0l-2.3,2.3l0,0l0,0h0c-0.2,0.2-0.6,0.2-0.8,0l-2.3-2.3l0,0 l0,0c-0.2-0.2-0.2-0.6,0-0.8l0,0c0.2-0.2,0.6-0.2,0.8,0l0,0l0,0l1.4,1.4l0.1,0.1v-9c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v9 l0.1-0.1l1.4-1.4l0,0h0C18.1,17.2,18.5,17.2,18.7,17.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.9cb5d11212c468087c0d56c0e2ecc92b.svg";
export { ForwardRef as ReactComponent };